<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="项目id：" prop="top_pid">
                <el-input v-model="model.top_pid"></el-input>
            </el-form-item>
            <el-form-item label="报告ID：" prop="report_id">
                <el-input v-model="model.report_id"></el-input>
            </el-form-item>
            <el-form-item label="设备类型：" prop="device_type">
                <el-input v-model="model.device_type"></el-input>
            </el-form-item>
            <el-form-item label="设备ID：" prop="device_id">
                <el-input v-model="model.device_id"></el-input>
            </el-form-item>
            <el-form-item label="设备编号：" prop="device_code">
                <el-input v-model="model.device_code"></el-input>
            </el-form-item>
            <el-form-item label="设备名称：" prop="device_name">
                <el-input v-model="model.device_name"></el-input>
            </el-form-item>
            <el-form-item label="日期：" prop="day">
                <el-input v-model="model.day"></el-input>
            </el-form-item>
            <el-form-item label="答案：" prop="answers">
                <el-input v-model="model.answers"></el-input>
            </el-form-item>
            <el-form-item label="其他问题：" prop="other_question">
                <el-input v-model="model.other_question"></el-input>
            </el-form-item>
            <el-form-item label="照片：" prop="pictures">
                <el-input v-model="model.pictures"></el-input>
            </el-form-item>
            <el-form-item label="是否检查：" prop="is_check">
                <el-input v-model="model.is_check"></el-input>
            </el-form-item>
            <el-form-item label="经度：" prop="lng">
                <el-input v-model="model.lng"></el-input>
            </el-form-item>
            <el-form-item label="维度：" prop="lat">
                <el-input v-model="model.lat"></el-input>
            </el-form-item>
            <el-form-item label="记录时间：" prop="add_time">
                <el-input v-model="model.add_time"></el-input>
            </el-form-item>
            <el-form-item label="记录人：" prop="creator_id">
                <el-input v-model="model.creator_id"></el-input>
            </el-form-item>
            <el-form-item label="记录人姓名：" prop="creator_name">
                <el-input v-model="model.creator_name"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'deviceInspectionLogEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                top_pid: '',
                report_id: '',
                device_type: '',
                device_id: '',
                device_code: '',
                device_name: '',
                day: '',
                answers: '',
                other_question: '',
                pictures: '',
                is_check: '',
                lng: '',
                lat: '',
                add_time: '',
                creator_id: '',
                creator_name: '',
            },
            getObj:{
                url:'/api/admin/deviceinspectionlog/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                xxxname: [
                    {required: true, message: 'xxx名称不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/deviceinspectionlog/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>